// @flow
import React from 'react';
import injectSheet from 'react-jss';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import { S, DARK } from '~/app/ui/tokens';

type Props = {
  value: string,
  classes: Object,
  onChange: (string) => void,
};

function CalendarPicker(props: Props) {
  const {
    value,
    onChange,
    classes
  } = props;

  return (
    <div className={classes.input}>
      <DatePicker
        selected={(value && moment(value).toDate()) || ''}
        onChange={newDate => onChange((newDate && moment(newDate).utc().format()) || '')}
      />
    </div>
  );
}

const styles = {
  input: {
    '& input': {
      color: 'hsl(0, 0%, 20%)',
      width: '100%',
      border: '1px solid hsl(0, 0%, 90%)',
      padding: '10px 10px',
      outline: 'none',
      fontSize: '13px',
      fontWeight: '400',
      borderRadius: '3px'
    },
    [DARK]: { '& input': { color: S.fg, borderColor: S.fieldLine, background: S.field } }
  },
  timezoneSelect: {
    marginBottom: '20px'
  }
};

export default injectSheet(styles)(CalendarPicker);
